/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.tickets.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.userPreferences'
])

.controller('LayoutsTicketsListController', ['$scope', '$state', '$timeout', '$uibModal', '$filter', 'HelpersService', 'ApiService', 'ValidateService', 'PermissionsService', 'GridStateFactory', 'GridDefinitionFactory', 'UserPreferencesService', function($scope, $state, $timeout, $uibModal, $filter, HelpersService, ApiService, ValidateService, PermissionsService, GridStateFactory, GridDefinitionFactory, UserPreferencesService) {

    $scope.layoutsTicketsList = {

      model: [],

      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

      lastSearchQuery: '',
      searchQuery: '',

      isSearching: false,

      viewId: '',
      layoutsTicketsListGridName: $state.current.name+'.grid0',

      optionsOverride: {
        enableGridMenu: false,
        data: 'layoutsTicketsList.model',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.layoutsTicketsList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns) {
            $scope.layoutsTicketsList.onDataGridSortChange(grid, columns);
          },

          onDblClick: function (item) {
            $scope.layoutsTicketsList.onDblClick(item);
          },

          remove: function(item) {
            $scope.layoutsTicketsList.remove(item);
          },

          showEvent: function(item) {
            $scope.layoutsTicketsList.showEvent(item);
          }
        },
        columnDefs: [
          {
            field: 'id',
            displayName: 'Id',
            visible: false
          },
          {
            field: 'name',
            displayName: 'Name',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'description',
            displayName: 'description'
          },
          {
            field: 'currentStatus',
            displayName: 'Status',
            cellTemplate: '<div class="ui-grid-cell-contents">' +
            '<span data-ng-show="{{ row.entity.status.published }}">Published</span>' +
            '<span data-ng-show="{{ !row.entity.status.published }}">Draft</span>' +
            '</div>',
            enableSorting: false
          },
          {
            field: 'assigned',
            displayName: 'Assigned',
            cellTemplate: '<div class="ui-grid-cell-contents">' +
            '<span data-ng-show="{{ row.entity.assigned }}">{{ row.entity.eventName || "Assigned" }}</span>' +
            '<span data-ng-show="{{ !row.entity.assigned }}">Unassigned</span>' +
            '</div>',
            enableSorting: false
          }

        ]
      },

      init: function() {
        this.viewId = $state.current.name;

        if (PermissionsService.check('TICKET_LAYOUTS_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'edit',
            displayName: 'Edit',
            enableSorting: false,
            onCellNavClick: function(row, col) {
              $scope.layoutsTicketsList.onDblClick(row);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
            enableHiding: false,
            width: 50
          });
        }

        this.optionsOverride.columnDefs.push({
          field: 'status.draftDate',
          displayName: 'Last Updated',
          cellFilter: 'date: "' + $scope.layoutsTicketsList.dateTimeFormat + '"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, $scope.layoutsTicketsList.dateTimeFormat);
          }
        });

        if (PermissionsService.check('TICKET_LAYOUTS_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.layoutsTicketsList.remove(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.remove(row.entity)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
            width: 80,
            enableHiding: false,
            enableSorting: false,
            visible: true
          });
        }

        this.gridDefinition.init(this.layoutsTicketsListGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        $scope.$emit('Application::contentTitleChange', {
          title: 'Ticket Layouts',
          buttonRight: {
            label: '+ Create Ticket Layout',
            permissions: 'TICKET_LAYOUTS_CREATE',
            action: function() {
              $scope.layoutsTicketsList.create();
            }
          }
        });

        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
      },

      getTicketLayouts: function() {
        ApiService.tickets.list(this.gridState.getGridState()).then(this.success.init, this.error.init);
      },

      initData: function() {
        var self = $scope.layoutsTicketsList, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getTicketLayouts();
      },

      query: function() {
        if (this.searchQuery !== this.lastSearchQuery) {
          this.isSearching = true;
          this.gridState.setPropertyValue('search', this.searchQuery);
          this.lastSearchQuery = this.searchQuery;
          $scope.$broadcast('DataGrid::Search', {name: this.layoutsTicketsListGridName});
        }
      },

      create: function() {
        $state.go('application.layouts.tickets.create.description');
      },

      remove: function(item) {
        var self = $scope.layoutsTicketsList;

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/layouts/tickets/modals/layoutsTicketsRemoveModal.tpl.html',
          size: 'md',
          controller: 'LayoutsTicketsRemoveModalController',
          resolve: {
            item : item,
            events: function() {
              return {
                data: {
                  payload: []
                }
              };
            },
            allow: !item.assigned
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function() {
          ApiService.tickets.remove(item.id).then(function() {
            self.getTicketLayouts();
          });
        }, function() {
          // Do nothing
        });
      },

      showEvent: function(item) {
        var self = $scope.layoutsTicketsList;
        $state.go('application.programsInstance', {id: item.eventId});
      },

      success: {
        init: function(response) {
          var self = $scope.layoutsTicketsList;
          self.model = response.data.payload.list;
          self.isSearching = false;
          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          }, 10);
        }
      },

      error: {
        init: function(response) {
          var self = $scope.layoutsTicketsList;
          self.isSearching = false;
          self.gridDefinition.isLoaded = true;
        }
      },

      onDblClick: function(item) {
        var self = $scope.layoutsTicketsList;
        $state.go('application.layouts.tickets.edit.description', { id: item.entity.id });
      },

      onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
        var self = $scope.layoutsTicketsList,
          data = {
            currentPage: newPageNumber || 1,
            pageSize: newPageSize || this.gridDefinition.options.paginationPageSize
          };

        self.gridState.updateGridState(data.currentPage, data.pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }

        self.getTicketLayouts();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.layoutsTicketsList,
          data = columns[0];

        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);

          self.getTicketLayouts();
        }
      }

    };

    $scope.layoutsTicketsList.init();

}]);